import * as e from "react";
const l = (a) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 4h6V3a1 1 0 112 0v1h1a3 3 0 013 3v12a3 3 0 01-3 3H6a3.001 3.001 0 01-2.836-2.018C2.984 19.46 3.448 19 4 19s.995.543 1.46.842c.155.1.34.158.54.158h12a1 1 0 001-1v-8H5a1 1 0 11-2 0V7a3 3 0 013-3h1V3a1 1 0 112 0v1zM6 6a1 1 0 00-1 1v2h14V7a1 1 0 00-1-1H6z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M10.613 12.21l.094.083 2.5 2.5a1 1 0 01.083 1.32l-.083.094-2.5 2.5a1 1 0 01-1.497-1.32l.083-.094.791-.793H4a1 1 0 01-.993-.883L3 15.5a1 1 0 01.883-.993L4 14.5h6.085l-.792-.793a1 1 0 01-.083-1.32l.083-.094a1 1 0 011.32-.083z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
